import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

export const DocsEmptyState = ({ className }: PropsWithClassNameI) => (
  <div
    className={clsxMerge(
      "flex size-full flex-col items-center justify-center p-4 text-black/60",
      className
    )}
  >
    <span className="typography-header-6">Coming soon.</span>
    <span className="typography-header-8">Please check back later.</span>
  </div>
);
